
import { Component, Prop } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'
import { IFilter } from '../helpers/types'

@Component({
  template: `
  <div class='product-filter'>
    <div class='product-filter__title'>{{ filter.title }}</div>
    <multiselect  :options='opionList'
                  :placeholder='filter.placeholder'
                  :value='value'
                  @input='$emit("input", $event)'
                  label='value'
                  :custom-label='propertyLabel'
                  track-by="value"
                  open-direction='below'
                  >
      <template slot="singleLabel" slot-scope="{ option }">
        <div class='flex flex-align-center'>
          <i class="icons8-delete" @keypress.enter.prevent="removeElement()" @mousedown.prevent="removeElement()" :title='removeNote'></i>
          <div class='label'>{{ propertyValue(option) }}</div>
        </div>
      </template>
    </multiselect>
  </div>
  `
})
export default class ProductFilter extends Mixin {
  @Prop() filter: IFilter
  @Prop() value: any
  @Prop({ default: '' }) removeNote: string

  get opionList(): any[] {
    return this.customSort(this.filter.values.filter(elm => elm.value != null))
  }

  extractParts(str: string): [string, number | null] {
    const match = str.match(/(\d+)/);
    const number = match ? parseInt(match[0], 10) : null;
    const letters = match
      ? str.slice(0, match.index).trim().toLowerCase()
      : str.trim().toLowerCase();
    return [letters, number];
  }

  /**
   * Sorts an array of objects by their 'value' property using the following rules:
   * - If all values are purely numeric, sort by numbers.
   * - If values contain letters or symbols:
   *    - If none of the values contain numbers, sort alphabetically.
   *    - If any value contains a number:
   *        - Extract the text prefix and numeric part.
   *        - Sort first by the prefix (alphabetically), then by the number.
  */
  customSort(arr: any[]): any[] {
    const isNumericOnly = (str: string) => /^\d+$/.test(str);
    const hasLetter = (str: string) => /[^\d\s]/.test(str);
    const allNumeric = arr.every(obj => isNumericOnly(obj.value));
    const anyLetter = arr.some(obj => hasLetter(obj.value));
    const allWithoutNumbers = arr.every(obj => obj.value.match(/\d+/) === null);

    return arr.sort((a, b) => {
      const aVal = a.value;
      const bVal = b.value;

      if (allNumeric) {
        return parseInt(aVal) - parseInt(bVal);
      }

      if (anyLetter) {
        if (allWithoutNumbers) {
          return aVal.localeCompare(bVal, undefined, { sensitivity: "base" });
        } else {
          const [aLetters, aNumber] = this.extractParts(aVal);
          const [bLetters, bNumber] = this.extractParts(bVal);

          const letterCompare = aLetters.localeCompare(bLetters);
          if (letterCompare !== 0) return letterCompare;

          if (aNumber === null && bNumber === null) return 0;
          if (aNumber === null) return 1;
          if (bNumber === null) return -1;

          return aNumber - bNumber;
        }
      }

      return aVal.localeCompare(bVal, undefined, { sensitivity: "base" });
    });
  }

  removeElement(){
    this.$emit("input", null)
  }

  propertyLabel(item: any) {
    if(item.value == 'True' || item.value == 'False') return this.$options?.filters?.t(`${item.value.toLowerCase()}Label`)
    if(item.unit) return item.value + ' ' + item.unit

    return item.value
  }

  propertyValue(prop: any): string {
    if(prop.value == 'True' || prop.value == 'False') return this.$options?.filters?.t(`${prop.value.toLowerCase()}Label`)
    if(prop.unit) return prop.value + ' ' + prop.unit

    return prop.value
  }
}
